import { Position, Snackbar } from '@el8/vital';

/*
 * It uses a blueprint position constants:
 * https://github.com/palantir/blueprint/blob/develop/packages/core/src/common/position.ts
 */
const AppSnackbar = Snackbar.create({ position: Position.RIGHT_TOP });

/**
 * Shows a toast in the bottom left of the window to notify the user of something.
 *
 * @param {string} message - the message to show
 * @returns {string} a unique key that identifies the toast being shown. This is
 * not used at the moment, but may become useful in the future as we expand our
 * use cases for toasts (such as to allow updating currently-showing toasts).
 */
export const notify = (message: string): string => AppSnackbar.show({ message });
